import React from "react";
const ButtonIcon = () => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "17", height: "19", viewBox: "0 0 19 19" }, /* @__PURE__ */ React.createElement("g", { fill: "none", fillRule: "evenodd", stroke: "currentColor", transform: "translate(1)" }, /* @__PURE__ */ React.createElement("rect", { width: "14.211", height: "7", x: "1.395", y: "5.5", rx: "3.5" }), /* @__PURE__ */ React.createElement("path", { d: "M11.034 7.541c1.246-.305 2.063.18 2.453 1.459" })));
export {
  ButtonIcon
};
//# sourceMappingURL=ButtonIcon.js.map
